import React from "react";

// Shim imports
import Card from "../../Component/MDBShim/Card";
import CardBody from "../../Component/MDBShim/CardBody";
import Container from "../../Component/MDBShim/Container";
import Spinner from "../../Component/MDBShim/Spinner";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import MDBTable from "../../Component/MDBShim/MDBTable";
import MDBTableBody from "../../Component/MDBShim/MDBTableBody";
import MDBTableHead from "../../Component/MDBShim/MDBTableHead";

import AccountService from "../Security/AccountService/accountService";
import ReactTooltip from "react-tooltip";
import LayerLegacy from "../../LayerLegacy";
import MainContext from "../../Context/MainContext/MainContext";

// The imports from metrial UI
import MUIBox from "@mui/material/Box";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUITextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import MUIStack from "@mui/material/Stack";
import MUIButton from "@mui/material/Button";
import MUISearchIcon from "@mui/icons-material/Search";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIFileDownloadIcon from "@mui/icons-material/FileDownload";
import MUIGrid from "@mui/material/Grid2";
import MUITooltip from "@mui/material/Tooltip";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";

const fixedLightMaterialUITheme = createTheme({
  palette: { mode: "light" },
});

export default class accountList extends LayerLegacy {
  constructor(props) {
    super(props);

    const data = {
      columns: [
        {
          label: "ID",
          field: "id",
        },
        {
          // label: <span data-tip={'Sort by Account Name'} onClick={() => this.sortTable('account')} style={{cursor: 'pointer'}}>Account</span>,
          label: "Account",
          field: "account",
        },
        {
          label: "Sales Rep",
          field: "owner",
        },
        {
          label: "Type",
          field: "type",
        },
        {
          label: "City",
          field: "city",
        },
        {
          label: "State",
          field: "state",
        },
        {
          label: "Zip",
          field: "zip",
        },
        {
          label: "Phone",
          field: "phone",
        },
        {
          label: "Is Master",
          field: "isMaster",
        },
        {
          label: "Master Acc. Name",
          field: "masterAccountName",
        },
      ],
      rows: [],
    };

    this.state = {
      data: data,
      isLoaded: true,
      allLocs: [],
      allSalesReps: [],
      locationsSelect: [
        {
          label: "Loading...",
          value: "loading",
        },
      ],
      salesRepsSelect: [
        {
          label: "Loading...",
          value: "loading",
        },
      ],
      locationsSelected: [],
      salesRepsSelected: "",
      search: "",
      foundAccounts: [],
      accountModalOpen: false,
    };
  }

  static contextType = MainContext; // For legacy class components

  componentDidMount() {
    this.getLocationsOptions();
    this.getSalesRepsOptions();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { salesReps, currentUser, allLocations } = this.context;
    let st = this.state;
    if (
      st.allLocs.length !== allLocations.length &&
      st.currUser !== currentUser
    ) {
      this.getLocationsOptions();
    }
    if (st.allSalesReps.length !== salesReps.length) {
      this.getSalesRepsOptions();
    }
  }

  clientCSV(stateData, filename) {
    let result,
      ctr,
      keys = [],
      headers = [
        "id",
        "name",
        "group",
        "owner",
        "account Type",
        "address",
        "city",
        "state",
        "zip",
        "phone",
        "fax",
        "email",
        "marketingCampaign",
      ],
      columnDelimiter = ",",
      lineDelimiter = "\n";

    if (stateData.length === 0) {
      return null;
    }

    let h = stateData[0];
    for (let prop in h) {
      if (prop !== "notes" && prop !== "addrLine2" && prop !== "addrLine3") {
        keys.push(prop);
      }
      if (prop === "name") {
        keys.push("group");
      }
    }

    let replace = ["name", "group"];

    result = "";
    result += headers.join(columnDelimiter);
    result += lineDelimiter;

    stateData.forEach(function (item) {
      ctr = 0;
      item.group = "no group";
      keys.forEach(function (key) {
        let v = "";
        if (ctr > 0) result += columnDelimiter;

        switch (key) {
          case "group":
            v = "no group";
            break;
          case "addrLine1":
            v =
              (item.addrLine1 ? item.addrLine1.replace(/,/g, " ") : "") +
              (item.addrLine2 ? " " + item.addrLine2.replace(/,/g, " ") : "") +
              (item.addrLine3 ? " " + item.addrLine3.replace(/,/g, " ") : "");
            break;
          case "notes":
            break;
          default:
            v = item[key] || "no " + key;
            break;
        }

        if (replace.indexOf(key) > -1 && v != null) {
          result += v.replace(/,/g, " ");
        } else {
          result += v;
        }

        ctr++;
      });
      result += lineDelimiter;
    });

    this.downloadBlob(result, filename);
  }

  //this actually prompts the download
  downloadBlob(csvData, filename) {
    let blob = new Blob([csvData], {
      type: "application/csv;charset=utf-8;",
    });

    if (window.navigator.msSaveBlob) {
      // FOR IE BROWSER
      navigator.msSaveBlob(blob, filename);
    } else {
      // FOR OTHER BROWSERS
      let link = document.createElement("a"),
        csvUrl = URL.createObjectURL(blob);

      link.href = csvUrl;
      link.style = "visibility:hidden";
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  getSalesRepsOptions(e) {
    const { salesReps, currentUser, userprofileLocationsIndexed } =
      this.context;

    let options = [];
    let locs = e && e.length > 0 ? e.map((x) => x.value) : [];

    if (currentUser.role !== "SALES") {
      salesReps.map((rep) => {
        const userProfileLocationsForRep = Object.values(
          userprofileLocationsIndexed,
        ).filter((userprofileLocation) => {
          return userprofileLocation.userprofileId === rep.id;
        });

        const repLocationIds = userProfileLocationsForRep.map(
          (userprofileLocation) => userprofileLocation.locationsId,
        );

        if (
          rep.active === true &&
          (!e ||
            e.length === 0 ||
            repLocationIds.some((id) => locs.includes(id)))
        ) {
          return options.push({
            label: rep.firstname + " " + rep.lastname,
            value: rep.id,
          });
        }
        return null;
      });
    } else if (currentUser.active === true) {
      options.push({
        label: currentUser.firstname + " " + currentUser.lastname,
        value: currentUser.id,
      });
    }

    this.setState({
      salesRepsSelect: options,
      allSalesReps: salesReps,
    });
  }

  getLocationsOptions() {
    const {
      currentUser,
      allLocations,
      userprofileLocationsIndexed,
      locationsIndexed,
    } = this.context;

    let select = [],
      locations = [],
      cu = currentUser;
    if (cu.role === "SALES") {
      const userProfileLocationsForCurrentUser = Object.values(
        userprofileLocationsIndexed,
      ).filter((userprofileLocation) => {
        return userprofileLocation.userprofileId === cu.id;
      });

      locations = userProfileLocationsForCurrentUser
        .map((userprofileLocation) => {
          return locationsIndexed[userprofileLocation.locationsId];
        })
        .filter((location) => {
          return location != null;
        });
    } else {
      locations = allLocations;
    }

    locations.map((location) => {
      // Populates the locations dropdown depending on which locations the user is in...JK
      return select.push({
        label: location.name,
        value: location.id,
      });
    });

    this.setState({
      locationsSelect: select,
      allLocs: allLocations,
    });
  }

  handleLocationChange = (newValue) => {
    this.setState({
      locationsSelected: newValue,
    });
    this.getSalesRepsOptions(newValue);
  };

  handleSaleRepChange = (e) => {
    this.setState({
      salesRepsSelected: e,
    });
  };

  //   const { currentUser } = this.context;
  //   let st = this.state;

  //   let disabled = true;

  //   if (currentUser?.role && currentUser.role.indexOf("ADMIN") > -1) {
  //     disabled = false;
  //   }

  //   const styles = {
  //     menu: (provided, state) => ({
  //       ...provided,
  //       color: "black",
  //     }),
  //   };

  //   // old
  //   return (
  //     <MDBCardHeader
  //       style={{
  //         paddingTop: 12,
  //         paddingBottom: 8,
  //         marginBottom: 10,
  //         color: "white",
  //         fontSize: 18,
  //         backgroundColor: "#5881C1",
  //       }}
  //     >
  //       <MDBRow>
  //         <MDBCol md={"3"}>
  //           <Select
  //             placeholder="Select Location"
  //             closeMenuOnSelect={false}
  //             isMulti
  //             styles={styles}
  //             options={st.locationsSelect}
  //             onChange={this.handleLocationChange.bind(this)}
  //             value={st.locationsSelected}
  //           />
  //         </MDBCol>
  //         <MDBCol md={"3"}>
  //           <Select
  //             placeholder="Select Sales Rep"
  //             isClearable
  //             styles={styles}
  //             options={st.salesRepsSelect}
  //             onChange={this.handleSaleRepChange.bind(this)}
  //             value={st.salesRepsSelected}
  //           />
  //         </MDBCol>
  //         <MDBCol md={"3"}>
  //           <form
  //             onSubmit={(e) => {
  //               this.filterClicked(e);
  //             }}
  //           >
  //             <MDBInput
  //               label="Search..."
  //               outline
  //               style={{ backgroundColor: "white" }}
  //               containerClass={"smallMargin"}
  //               value={st.search}
  //               onChange={(e) => {
  //                 this.setState({
  //                   search: e.target.value,
  //                 });
  //               }}
  //             />
  //           </form>
  //         </MDBCol>
  //         <MDBCol md={"3"}>
  //           <Button
  //             outline
  //             size="sm"
  //             rounded
  //             className="px-2 toolbarButton"
  //             color={"info"}
  //             data-tip={"Search Accounts"}
  //             data-place={"bottom"}
  //             onClick={(e) => this.filterClicked(e)}
  //           >
  //           </Button>
  //           <Button
  //             outline
  //             size="sm"
  //             rounded
  //             className="px-2 toolbarButton"
  //             color={"success"}
  //             data-tip={"Add New Account"}
  //             data-place={"bottom"}
  //             onClick={() => window.open("/account/create", "_blank")}
  //           >
  //           </Button>
  //           <Button
  //             outline
  //             size="sm"
  //             rounded
  //             className="px-2 toolbarButton"
  //             color={"secondary"}
  //             data-tip={"Download CSV"}
  //             data-place={"bottom"}
  //             onClick={this.clientCSV.bind(
  //               this,
  //               this.state.foundAccounts,
  //               "Accounts.csv",
  //             )}
  //           >
  //           </Button>
  //           &nbsp;
  //         </MDBCol>

  //         <ReactTooltip />
  //       </MDBRow>
  //     </MDBCardHeader>
  //   );
  // }
  // New renderFilters By Yours Truly :)
  renderFilters() {
    return (
      <MUIBox
        sx={{
          backgroundColor: "white",
          display: "flex",
          p: 2,
          alignItems: "center",
          gap: 3,
        }}
      >
        {/* The Grid holding it all together */}
        <MUIGrid container spacing={2}>
          {/* drop down for the locations  */}
          <MUIGrid
            size={{
              xs: 12,
              sm: 6,
              md: 4,
              lg: 3,
            }}
          >
            <MUIAutocomplete
              multiple
              options={this.state.locationsSelect}
              onChange={(e, newValue) => {
                this.handleLocationChange(newValue);
              }}
              value={this.state.locationsSelected}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              sx={{ bgcolor: "white", width: "fullWidth" }}
              renderInput={(params) => (
                <MUITextField
                  {...params}
                  label="Select Location"
                  variant="standard"
                />
              )}
            />
          </MUIGrid>
          {/* dropdown for the sales reps */}
          <MUIGrid
            size={{
              xs: 12,
              sm: 6,
              md: 3,
            }}
          >
            <MUIAutocomplete
              options={this.state.salesRepsSelect}
              onChange={(e, newValue) => this.handleSaleRepChange(newValue)}
              value={this.state.salesRepsSelected || null}
              isOptionEqualToValue={(option, value) =>
                value != null && option.value === value.value
              }
              getOptionLabel={(option) => option.label}
              sx={{ bgcolor: "white", width: "fullWidth" }}
              renderInput={(params) => (
                <MUITextField
                  {...params}
                  label="Select Sales Rep"
                  variant="standard"
                />
              )}
            />
          </MUIGrid>
          {/* Serach bar */}
          <MUIGrid
            size={{
              xs: 12,
              sm: 6,
              md: 3,
            }}
          >
            <form
              onSubmit={(e) => {
                this.filterClicked(e);
              }}
            >
              <MUITextField
                sx={{ bgcolor: "white", width: "100%" }}
                label="Search"
                size="small"
                value={this.state.search}
                onChange={(e) => {
                  this.setState({ search: e.target.value });
                }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <MUISearchIcon />
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </form>
          </MUIGrid>

          {/* Buttons */}
          <MUIGrid
            size={{
              xs: 12,
              sm: 6,
              md: 3,
            }}
          >
            <MUIStack direction="row" spacing={1}>
              <MUIButton
                variant="outlined"
                color="primary"
                size="small"
                onClick={(e) => this.filterClicked(e)}
              >
                <MUISearchIcon />
              </MUIButton>
              <MUITooltip title="Add Account">
                <MUIButton
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={() => window.open("/account/create", "_blank")}
                >
                  <MUIAddIcon />
                </MUIButton>
              </MUITooltip>
              <MUITooltip title="Download CSV">
                <MUIButton
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={() =>
                    this.clientCSV(this.state.foundAccounts, "Accounts.csv")
                  }
                >
                  <MUIFileDownloadIcon />
                </MUIButton>
              </MUITooltip>
            </MUIStack>
          </MUIGrid>
        </MUIGrid>
      </MUIBox>
    );
  }

  filterClicked = (e) => {
    e.preventDefault();
    if (!this.state.search && !this.state.salesRepsSelected) {
      return NotistackEnqueueSnackbar(
        "Please select a rep or enter text to search by",
        {
          variant: "warning",
        },
      );
    }

    this.setState({
      isLoaded: false,
      selectedAccounts: [],
    });
    this.retrieveAccounts();
  };

  retrieveAccounts() {
    let st = this.state,
      reps = [],
      filters = {};

    // Get users in the sales rep dropdown and add to the filter
    if (st.salesRepsSelected) {
      reps.push(st.salesRepsSelected.value);
    }
    //add the user selected if any
    filters.ids = reps.toString();
    if (st.search) {
      filters.q = st.search;
    }

    AccountService.getAllAccounts(filters)
      .then((res) => {
        this.setState({ foundAccounts: res });

        this.buildRows(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  handleRowClick(account) {
    window.open("/account/" + account.id + "/detail", "_blank");
  }

  buildRows(accounts) {
    let ary = [],
      dt = this.state.data;

    accounts.forEach((account, index) => {
      ary.push({
        id: account.id,
        account: account.name,
        owner: account.owner || "No Sales-Rep",
        type: account.accountType || "No Type",
        city: account.city ? account.city : "No City",
        state: account.state ? account.state : "No State",
        zip: account.zip ? account.zip : "No Zip Code",
        phone: account.phoneNumber || "No Phone",
        isMaster: account.isMaster ? "Yes" : "No",
        masterAccountName: account.masterAccountName,
        clickEvent: () => this.handleRowClick(account),
      });
    });

    dt.rows = ary;

    this.setState({
      data: dt,
      isLoaded: true,
    });
  }

  renderTable() {
    if (this.state.isLoaded === true) {
      return (
        <div>
          <style>{`
                        .account-table-hover tbody tr:hover {
                            background-color: #e3f0ff !important;
                            transition: background 0.2s;
                        }
                    `}</style>
          <MDBTable
            maxHeight={"65vh"}
            responsive
            scrollY
            striped
            small
            style={{ cursor: "pointer" }}
            className="account-table-hover"
          >
            <MDBTableHead columns={this.state.data.columns} />
            <MDBTableBody rows={this.state.data.rows} />
          </MDBTable>
          <ReactTooltip />
        </div>
      );
    } else {
      return <div></div>;
    }
  }

  renderLoadingSpinner() {
    return (
      <Container className="mt-5">
        <div style={{ textAlign: "center", verticalAlign: "center" }}>
          <Spinner multicolor />
        </div>
      </Container>
    );
  }

  renderContent() {
    return (
      <ThemeProvider theme={fixedLightMaterialUITheme}>
        <div
          style={{ overflowY: "hidden", overflowX: "hidden", minHeight: 500 }}
        >
          {this.renderFilters()}
          <Card style={{ margin: "1%" }}>
            <CardBody>
              {this.state.isLoaded
                ? this.renderTable()
                : this.renderLoadingSpinner()}
            </CardBody>
          </Card>
        </div>
      </ThemeProvider>
    );
  }
}
